import getValue from "object-getvalue"

import AC from "components/Stacker/constants/AddressConstants"
import SIC from "components/Stacker/constants/SignInConstants"
import COC from "components/Stacker/constants/CheckoutConstants"
import GMC from "components/Stacker/constants/GiftMessageConstants"
import ACC from "components/Stacker/constants/AccountConstants"
import { getDY_SR } from "stackerConfig"

export const initialState = {
  meta: {
    isDataLoading: false,
    isError: false,
    message: "",
    isModalDataLoading: false,
    isEditSuccess: false,
    isAddressFetched: false,
    addressFormMode: "",
    isAddressListLoading: false,
    googleAddressLoader: false,
  },
  data: {
    defaultSelectedCountryCode: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.config.global.defaultSelectedCountryCode"
    ),
    countryStateData: [],
    countryList: [],
    countryStateMap: {},
    defaultSelectedCountry: {},
    shippingAddress: {
      savedShippingAddresses: {},
      currentSelection: {},
      suggestedAddress: null,
    },
    keyDownFocusFlag: false,
  },
  personalInformation: {
    selectedState: {},
  },
  editAddressData: {},
  deleteAddressData: {},
  googleAddressLookup: {
    // 'field/id': {
    // predictions:[],
    // selectedFormattedAddress: [],
    // selectedInputAddress: '',
    // }
  },
}

export default function addressReducer(previousState = initialState, action) {
  let newState
  let id
  let data

  switch (action.type) {
    case ACC.ACCOUNT_FETCH_PERSONAL_INFORMATION_SUCCESS: {
      let selectedState = {}
      const { state, country: countryData } = action.payload
      const isCountryStateMap =
        Object.keys(previousState.data.countryStateMap).length > 0
      if (countryData && isCountryStateMap) {
        ;[selectedState] = previousState.data.countryStateMap[
          countryData
        ].regions.filter((stateObj) => {
          return stateObj.value === state
        })
      }
      return {
        ...previousState,
        personalInformation: {
          ...previousState.personalInformation,
          selectedState,
        },
      }
    }

    case AC.ADDRESS_COUNTRY_STATE_FETCHED: {
      const countryList = []
      const countryStateMap = {}
      const { defaultSelectedCountryCode } = previousState.data
      let { defaultSelectedCountry } = previousState.data

      action.payload.forEach((country) => {
        const currentCountry = {
          countryCode: country.countryCode,
          countryName: country.countryName,
        }

        countryList.push(currentCountry)

        countryStateMap[country.countryCode] = {
          countryName: country.countryName,
          regions: country.regions,
        }

        if (country.countryCode === defaultSelectedCountryCode) {
          defaultSelectedCountry = currentCountry
        }
      })

      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: false,
          message: initialState.meta.message,
        },
        data: {
          ...previousState.data,
          countryStateData: action.payload,
          countryStateMap,
          countryList,
          defaultSelectedCountryCode,
          defaultSelectedCountry,
        },
      }
    }

    case AC.ADDRESS_API_STARTED: {
      newState = {
        ...previousState,
        meta: {
          ...previousState.meta,
          message: initialState.meta.message,
          isDataLoading: true,
          isEditSuccess: false,
        },
      }
      return newState
    }

    case AC.ADDRESS_FETCH_API_STARTED: {
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          message: initialState.meta.message,
          isAddressListLoading: true,
        },
      }
    }
    case AC.ADDRESS_MODAL_API_STARTED: {
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          message: initialState.meta.message,
          isModalDataLoading: true,
        },
      }
    }

    case AC.ADDRESS_SUGGESTED: {
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: false,
          message: initialState.meta.message,
          isModalDataLoading: false,
          // addressFormMode: ''
        },
        data: {
          ...previousState.data,
          shippingAddress: {
            ...previousState.data.shippingAddress,
            suggestedAddress: action.payload.suggestedAddress,
            currentSelection: action.payload.currentSelection,
          },
        },
      }
    }
    case AC.ADDRESS_VALIDATED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: false,
          isModalDataLoading: false,
          message: initialState.meta.message,
          addressFormMode: "",
        },
        data: {
          ...previousState.data,
          shippingAddress: {
            ...previousState.data.shippingAddress,
            suggestedAddress: initialState.data.suggestedAddress,
            currentSelection: action.payload.currentSelection,
          },
        },
      }

    case AC.ADDRESS_CHANGE_SELECTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: false,
          message: initialState.meta.message,
        },
        data: {
          ...previousState.data,
          shippingAddress: {
            ...previousState.data.shippingAddress,
            suggestedAddress: initialState.data.suggestedAddress,
            currentSelection: action.payload,
          },
        },
      }

    case AC.ADDRESS_CLEAR_SUGGESTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: false,
          message: initialState.meta.message,
          // addressFormMode: ''
        },
        data: {
          ...previousState.data,
          shippingAddress: {
            ...previousState.data.shippingAddress,
            suggestedAddress: initialState.data.suggestedAddress,
          },
        },
      }

    case AC.ADDRESS_OPERATION_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isAddressListLoading: false,
          isError: true,
          message: action.payload || "System error",
        },
      }

    // Registered User
    case AC.ADDRESS_SAVED_FETCHED: {
      const savedShippingAddressesObj = {}
      let defaultAddressId

      action.payload.forEach((address) => {
        savedShippingAddressesObj[address.addressId] = address
        if (address.isDefault) {
          defaultAddressId = address.addressId
        }
      })

      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: false,
          isModalDataLoading: false,
          isAddressListLoading: false,
          message: initialState.meta.message,
          isAddressFetched: true,
          isEditSuccess: false,
          addressFormMode: "",
        },
        data: {
          ...previousState.data,
          shippingAddress: {
            ...previousState.data.shippingAddress,
            savedShippingAddresses: savedShippingAddressesObj,
          },
          defaultAddressId,
        },
      }
    }

    case AC.ADDRESS_UPDATE_SUCCESS:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: false,
          isModalDataLoading: false,
          message: "",
          isEditSuccess: true,
        },
        data: {
          ...previousState.data,
        },
      }

    case AC.ADDRESS_FORM_SET_MODE:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          addressFormMode: action.payload,
        },
      }

    case AC.ADDRESS_EDIT_SET:
      return {
        ...previousState,
        editAddressData: action.payload,
      }

    case AC.ADDRESS_DELETE_SET:
      return {
        ...previousState,
        deleteAddressData: action.payload,
      }

    case SIC.SIGNIN_IN_PROGRESS:
      return {
        ...previousState,
        meta: {
          ...initialState.meta,
        },
        data: {
          ...previousState.data,
          ...initialState.shippingAddress,
        },
      }

    case GMC.GIFT_MESSAGE_REQUIRED_ERROR_RESET:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isError: false,
          message: "",
        },
      }

    case AC.ADDRESS_DISPLAY_ERROR_PROCEED_PAYMENT:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isError: true,
          message: action.payload,
        },
      }

    case COC.CHECKOUT_RESET_DATA: {
      return { ...initialState }
    }

    case AC.ADDRESS_PREDICTION_FETCH: {
      ;({ id, data } = action.payload)
      return {
        ...previousState,
        googleAddressLookup: {
          ...previousState.googleAddressLookup,
          [id]: {
            ...previousState.googleAddressLookup[id],
            predictions: data,
          },
        },
      }
    }
    case AC.ADDRESS_SET_INPUT_VALUE: {
      ;({ id, data } = action.payload)
      return {
        ...previousState,
        googleAddressLookup: {
          ...previousState.googleAddressLookup,
          [id]: {
            ...previousState.googleAddressLookup[id],
            selectedInputAddress: data,
          },
        },
      }
    }
    case AC.ADDRESS_FETCH_STARTED: {
      ;({ id, data } = action.payload)
      return {
        ...previousState,
        googleAddressLookup: {
          ...previousState.googleAddressLookup,
          [id]: {
            ...previousState.googleAddressLookup[id],
            googleAddressLoader: true,
          },
        },
      }
    }

    case AC.ADDRESS_FETCH_FORMATTED_ADDRESS_SUCCESS: {
      ;({ id, data } = action.payload)
      return {
        ...previousState,
        googleAddressLookup: {
          ...previousState.googleAddressLookup,
          [id]: {
            ...previousState.googleAddressLookup[id],
            selectedFormattedAddress: data,
            googleAddressLoader: false,
          },
        },
      }
    }

    case AC.ADDRESS_CLEAR_FORMATTED_ADDRESS: {
      ;({ id, data } = action.payload)
      return {
        ...previousState,
        googleAddressLookup: {
          ...previousState.googleAddressLookup,
          [id]: {
            ...previousState.googleAddressLookup[id],
            selectedFormattedAddress: [],
          },
        },
      }
    }

    case AC.ADDRESS_TOGGLE_KEY_DOWN_FOCUS:
      return {
        ...previousState,
        data: {
          ...previousState.data,
          keyDownFocusFlag: action.payload,
        },
      }

    default:
      return previousState
  }
}
